import { useClubData } from '../lib/club-data.context';

/**
 * Hook to fetch news for the opposition team
 * Uses the ClubDataContext to access centralized opposition news data
 */
export const useOppositionNews = () => {
  const { oppositionNews, isLoading, error } = useClubData();
  
  return { 
    news: oppositionNews,
    isLoading,
    error
  };
};